<template>
  <!-- <el-container class="index-con">
    <el-header class="index-header">
      <navcon></navcon>
    </el-header>
    <el-container class="index-con">
      <el-aside :class="showclass">
        <leftnav></leftnav>
      </el-aside>
      <el-container class="main-con">
        <el-main clss="index-main">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </el-container> -->

  <el-container class="index-con">
    <el-aside :class="showclass">
      <leftnav></leftnav>
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header">
        <navcon></navcon>
      </el-header>
      <el-main clss="index-main">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
// 导入组件
import axios from 'axios';
import navcon from '../components/navcon.vue'
import leftnav from '../components/leftnav.vue'
export default {
  name: 'index',
  data() {
    return {
      showclass: 'asideshow',
      showtype: false
    }
  },
  // 注册组件
  components: {
    navcon,
    leftnav
  },
  methods: {},
  created() {
    // 监听
    this.$root.Bus.$on('toggle', value => {
      if (value) {
        this.showclass = 'asideshow'
      } else {
        setTimeout(() => {
          this.showclass = 'aside'
        }, 300)
      }
    })
    const url = "http://223.112.208.206:8089/k3cloud/Kingdee.BOS.WebApi.ServicesStub.AuthService.ValidateUser.common.kdsvc"  // 设置请求的 URL
    axios.defaults.headers.post['Content-Type'] = 'application/json'; 
    const requestBody = JSON.stringify({
						"acctID": "6510e47300fbe6",
						"username": "administrator",
						"password": "qwe123!@#",
						"lcid": "2052"  ,
						"data": {
							"FormId": "BAH_WMSPutOnRecord",
							"FieldKeys": "FID,FBillNo,F_BAH_Entity_FEntryID,FApproveDate,FMaterialID.FNUMBER,FMaterialID.FName,FQty,FUnitId.FNUMBER,FUnitId.FName,FBoxID,FProduceDate,FExpiryDate,FEmployeeID.FName,FEmployeeID.FNUMBER,FDept.FName,FDept.FNUMBER,FInstockType.FName,FInstockType.FNUMBER,FU8BillNo",
							"FilterString": "FDocumentStatus ='C' AND FU8BillStatus ='KB'",
							"OrderString": "FID",
							"Limit": 3
						}
					});

axios.post(url, requestBody)
  .then(response => {
    console.log(response.data);  // 打印响应数据
  })
  .catch(error => {
    console.error(error);  // 打印错误信息
  });
  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
    // 弹出登录成功
    this.$message({
      message: '登录成功',
      type: 'success'
    })
  }
}
</script>
<style >
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.aside {
  width: 64px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}
.asideshow {
  width: 240px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}
.index-header,
.index-main {
  padding: 0px;
  border-left: 2px solid #333;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue